module.exports = __webpack_public_path__ + "static/1-db020663b0564ca35d2501cea4158ee1.jpeg";